<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import VCard from '@components/card/VCard/VCard.vue';
import AffiliateProgramCommissionsForm
  from '@modules/affiliate-program-commissions/submodules/edit/components/AffiliateProgramCommissionsForm/AffiliateProgramCommissionsForm.vue';
import {
  AFFILIATE_TRACKERS_LIST_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_TRACKERS,
} from '@modules/affiliate-trackers/constants';
import { useAffiliateTrackersConditionQuery } from '@modules/affiliate-trackers/submodules/condition/queries';
import { useCountriesQuery } from '@modules/countries/queries';
import { isString } from '@utils/guards';

const route = useRoute();

const id = computed(() => (isString(route.params.id) ? Number(route.params.id) : 0));

const { data, isLoading: isLoadingCondition } = useAffiliateTrackersConditionQuery(id);
const { data: countries, isLoading: isLoadingCountries } = useCountriesQuery();

const isLoading = computed(() => (isLoadingCondition.value || isLoadingCountries.value));
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateTrackersConditionPage'"
    :title="$getTranslation(TRANSLATION_GROUP_AFFILIATE_TRACKERS, 'CONDITION_HEADER')"
    type="form"
  >
    <div
      v-if="!isLoading && !data?.condition"
      class="text-muted-color"
    >
      {{ $getTranslation(TRANSLATION_GROUP_AFFILIATE_TRACKERS, 'CONDITION_IS_ABSENT') }}
    </div>
    <AffiliateProgramCommissionsForm
      v-else
      :is-loading="isLoading"
      :commission="data?.condition"
      :countries="countries"
      :constants="data?.constants ? { constants: data?.constants } : undefined"
      :merchants-list="data?.merchants"
      hide-attributes
      is-readonly
      :back-route-label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_TRACKERS, 'CONDITION_BACK')"
      :back-route="{ name: AFFILIATE_TRACKERS_LIST_ROUTE_NAME }"
    />
  </VCard>
</template>
